export type Email = string & { __brand: 'Email' }

/** Longueur des colonnes `email` en base */
export const EMAIL_MAX_LENGTH = 255

/**
 * Normalisation des adresses qui n'entrent pas par un schéma vine : valeurs
 * relues de la base, entrées brutes de `request.input()`. La validation, elle,
 * est portée par `emailField()` (`@gozoki/api-types`).
 */
export function normalizeEmail(input: string): Email {
  return input.trim().toLowerCase() as Email
}
